import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from '../message.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-base-template',
  templateUrl: './base-template.component.html',
  styleUrls: ['./base-template.component.css']
})
export class BaseTemplateComponent implements OnInit, OnDestroy {
  public displayed: boolean;
  private userAuth: Subscription;

  constructor(private messageService: MessageService) {
    this.messageService.getTotalData().subscribe(totalData => {
      this.totalData = totalData;
    });
    this.messageService.getUrlPath().subscribe(path => {
      // console.log('---inside base ' + JSON.stringify(path));
      this.prevPath = path.prevPath;
      this.nextPath = path.nextPath;
    });
  }

  pageName: string;
  openModalButton: string;
  openModalButton1: string;
  breadcrumb: string;
  totalData: number;
  folderName: string;
  tabName: string;
  show: boolean;
  selected: number;
  prevPath: string;
  nextPath: string;
  pageSizeObj: any[];
  pageSizeSelected: number;

  @Output() modal = new EventEmitter();
  @Output() searchmodal = new EventEmitter();
  @Output() index = new EventEmitter();
  @Output() dataExportToExcel = new EventEmitter();
  @Output() tabledata = new EventEmitter();
  @Output() resetData = new EventEmitter();
  @Input() displayData: any;
  @Input() displayData1: any;
  @Input() previousOffset: any;
  @Input() nextOffset: any;
  @Output() pageSize = new EventEmitter();
  @Input() collectionSize: any;
  @Output() offset = new EventEmitter();
  @Input() pageNo: any;
  @Input() totalPage: any;
  @Input() hideBtn: boolean;
  @Input() hidePagination: boolean;
  @Input() showSearch: boolean;
  @Input() dataLoaded: boolean;
  @Input() showExportBtn: boolean;
  @Input() isExportDisable: boolean;
  @Input() showIndex: boolean;
  @Input() showResetBtn: boolean;

  view = false;
  add = false;
  edit = false;
  del = false;
  clientId: any;

  ngOnInit() {
    console.log(this.messageService.pageSelected);
    this.pageSizeSelected = this.messageService.pageSelected;
    this.pageSizeObj = this.messageService.pagination;
    this.displayed = true;
    this.totalData = 0;
  }

  openModal() {
    this.modal.emit();
  }
  searchModal() {
    this.searchmodal.emit();
  }
  createIndex() {
    this.index.emit();
  }
  exportToExcel() {
    this.dataExportToExcel.emit();
  }
  reset() {
    this.resetData.emit();
  }
  toggleViews() {
    this.displayed = !this.displayed;
  }

  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }

  getTableData() {
    this.tabledata.emit();
  }

  getNextData() {
    this.offset.emit({ 'offset': this.nextOffset, 'paginationType': 'next' });
  }

  getPreviousData() {
    this.offset.emit({ 'offset': this.previousOffset, 'paginationType': 'prev' });
  }

  onPageSizeChange(value: any) {
    const page_size = this.pageSizeObj[value].value;
    this.pageSize.emit(page_size);
  }

  ngOnDestroy(): void {
    if (this.userAuth) {
      this.userAuth.unsubscribe();
    }
  }
}
